import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const client = axios.create({ baseURL: API_BASE });

// Анонимный идентификатор устройства — для одного бесплатного сканирования
export function deviceId() {
  try {
    let d = localStorage.getItem('deviceId');
    if (!d) {
      d = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2));
      localStorage.setItem('deviceId', d);
    }
    return d;
  } catch { return 'nodevice-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2); }
}

client.interceptors.request.use(cfg => {
  cfg.headers['X-Device-Id'] = deviceId();
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const api = {
  // Auth
  register: (data) => client.post('/auth/register', data),
  login:    (data) => client.post('/auth/login', data),
  me:       ()     => client.get('/auth/me'),

  // Calculations
  calculate:    (data)   => client.post('/calculations/calculate', data),
  calculateFree: (data)  => client.post('/calculations/calculate-free', data),
  freeStatus:    ()      => client.get('/calculations/free-status'),
  demo:          ()      => client.get('/calculations/demo'),
  natalSummary: (params) => client.get('/calculations/natal-summary', { params }),

  // Reports
  generatePdf: (data) =>
    client.post('/reports/generate-pdf', data, { responseType: 'blob' }),

  // AI explanations
  explainDay: (data) => client.post('/explain/explain', data),

  // Countries / cities
  countries: ()               => client.get('/countries/list'),
  citiesByCountry: (code, search = '') =>
    client.get(`/countries/${code}/cities`, { params: search ? { search } : {} }),
  utcOffset: (timezone, date, time) =>
    client.get('/geo/utc-offset', { params: { timezone, date, time: time || '12:00' } }),

  // Встроенные покупки: сервер сверяет покупку с Google/Apple, email берёт из токена
  verifyGoogle: (productId, purchaseToken) =>
    client.post('/payment/google/verify', { product_id: productId, purchase_token: purchaseToken }),
  verifyApple:  (transactionId) =>
    client.post('/payment/apple/verify', { transaction_id: transactionId }),

  // Удаление аккаунта (требование Google/Apple)
  deleteAccount: () => client.delete('/auth/account'),
};
